import { lazy } from 'react';
import { authModules } from 'app/auth';
import ABSUtils from '@abs/utils/ABSUtils';
import themesConfig from 'app/configs/themesConfig';

const Reports = lazy(() => import('./Reports'));

const ReportsConfig = {
	settings: {
		layout: {
			config: {}
		},
		theme: {
			main: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
			navbar: ABSUtils.IsDarkMode() ? themesConfig.timeliteDark : themesConfig.timelite,
		}
	},
	routes: [
		{
			path: '/tl/reports',
			element: <Reports />,
			auth: authModules.tl_default
		}
	]
};

export default ReportsConfig;
